export const itemLocalStorage = {
    userToken: "USER_TOKEN",
    appFormat: "APP_FORMAT",
    appMap: "APP_MAP",
    appUi: "APP_UI",
    appMapInteraction: "APP_MAP_INTERACTION_USER_",
    userLang: "USER_LANGUAGE_SETTINGS"
};